'use client'

import { useLoader } from '@/hooks/useLoader'
import Image from 'next/image'
import { motion, AnimatePresence } from 'framer-motion'

const LoadingScreen = ({ children }: { children: React.ReactNode }) => {
  const isLoaderRemoved = useLoader()

  return (
    <AnimatePresence>
      {!isLoaderRemoved ? (
        <motion.div
          className='fixed inset-0 z-50 flex items-center justify-center bg-bgColor'
          initial={{ opacity: 1 }} // Initial state when the component mounts
          animate={{ opacity: 1 }} // Animation state while visible
          exit={{ opacity: 0 }} // Exit animation when the component unmounts
          transition={{ duration: 0.5 }} // Smooth transition duration
        >
          <div className='text-center flex flex-col items-center'>
            <Image
              src='https://imagedelivery.net/COrEjiX90UMaVnfrARSGdQ/1ee529ea-5721-46ac-8595-b00309599800/public'
              alt='Loading'
              width={100}
              height={100}
              className='animate-spin'
            />
            <p className='mt-4 text-white text-2xl'>Loading contracts</p>
          </div>
        </motion.div>
      ) : <>{children}</>}
    </AnimatePresence>
  )
}

export default LoadingScreen
